"use client";
import { Component } from "react";
import { IBaseComponentProps } from "../props/IBaseComponentProps";
import Styles from './NSTabPage.module.css';

export interface NSTabPageTab extends IBaseComponentProps
{
	title: string;
	clicked: boolean;
	getContent: () => React.ReactNode;
}

export interface NSTabPageProps extends IBaseComponentProps
{
	tabs: NSTabPageTab[]
	container?: IBaseComponentProps
	activeTabIndex?: number;
}

export interface NSTabPageState
{
	activeTabIndex: number;
	isClicked: boolean[];
}

export class NSTabPage extends Component<NSTabPageProps, NSTabPageState>
{
	constructor(props: NSTabPageProps)
	{
		super(props);
		let activeTabIndex = this.props.activeTabIndex ?? 0;
		this.state = {
			activeTabIndex,
			isClicked: this.props.tabs.map((tab, index) => tab.clicked || activeTabIndex === index)
		};
	}
	setClicked(indices: number[], callback: () => void)
	{
		let isClicked = this.state.isClicked;
		for (let i = 0; i < indices.length; i++)
			isClicked[indices[i]] = true;
		this.setState({ isClicked }, callback);
	}
	override render()
	{
		return (
			<div
				id={this.props.id}
				className={`${Styles.ns_tab_page_panel} ${this.props.classList?.join(" ") ?? ""}`}
				style={this.props.style}>
				<ul className={Styles.ns_tab_page_titles_container}>
					{
						this.props.tabs.map((tab, index) => (
							<li
								key={`NSTabPage_li_key_${index}`}
								className={`${Styles.ns_tab_page_title} ${this.state.activeTabIndex === index ? Styles.ns_tab_page_title_active : ''}`}
								onClick={() =>
								{
									let isClicked = this.state.isClicked;
									isClicked[index] = true;
									this.setState({ activeTabIndex: index, isClicked })
								}}
							>
								{tab.title}
							</li>
						))
					}
				</ul>
				<div
					id={this.props.container?.id}
					className={this.props.container?.classList?.join(" ") ?? ""}
					style={{ ...this.props.container?.style }}
				>
					{
						this.props.tabs.map((tab, index) => (
							<div
								id={tab.id}
								key={`NSTabPage_div_key_${this.props.name}_${index}`}
								className={`${Styles.ns_tab_content_column} ${tab.classList?.join(" ") ?? ""}`}
								style={{ ...tab.style, display: index === this.state.activeTabIndex ? "flex" : "none" }}
							>
								{
									this.state.isClicked[index] ? tab.getContent() : <></>
								}
							</div>
						))
					}
				</div>
			</div>
		);
	}
}